import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface GuestCatalogSearchFormProps {
  query: string;
  disabled: boolean;
  onQueryChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function GuestCatalogSearchForm({
  query,
  disabled,
  onQueryChange,
  onSubmit,
}: GuestCatalogSearchFormProps) {
  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-3 sm:flex-row">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search by title, author, ISBN..."
          className="pl-9"
        />
      </div>
      <Button type="submit" disabled={disabled}>
        Search
      </Button>
    </form>
  );
}
